import instanceAxios from '../config/api'
import {
  ActeurAction,
  UpdateActorActionResponse,
  UserActionResponse,
} from '../types/actorActionTypes'

const API_URL = '/actorActions'

export const createActeurAction = async ({
  ActionId,
  RASCI,
}: {
  ActionId: string
  RASCI: Record<string, string[]>
}): Promise<ActeurAction> => {
  try {
    const response = await instanceAxios.post<ActeurAction>(API_URL, {
      ActionId,
      RASCI,
    })

    return response.data
  } catch (error) {
    throw new Error('Failed to create acteur action.')
  }
}
export const getActeursByActionId = async (actionId: string) => {
  try {
    const response = await instanceAxios.get<{
      message: string
      RASCI: ActeurAction
    }>(`${API_URL}/actorActionByActionId/${actionId}`)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch acteurs by action ID.')
  }
}
export const updateActorAction = async (
  id: string,
  updateData: { actionId: string; RASCI: ActeurAction['RASCI'] }
): Promise<UpdateActorActionResponse> => {
  try {
    const response = await instanceAxios.put<UpdateActorActionResponse>(
      `${API_URL}/${id}`,
      updateData
    )
    return response.data
  } catch (error) {
    console.error('Update error:', error)
    throw new Error(
      error instanceof Error ? error.message : 'Failed to update actor action.'
    )
  }
}
export const getMyActions = async (): Promise<UserActionResponse> => {
  try {
    const response = await instanceAxios.get<UserActionResponse>(
      `${API_URL}/my-actions`
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch user actions.')
  }
}
